import React from 'react';
import {
    Stack,
    Button,
    TextField,
    Icon
} from '@shopify/polaris';
import {
    ChevronRightMinor, DeleteMajor, CircleInformationMajor
} from '@shopify/polaris-icons';

class ValueMappingComponent extends React.Component {

    timeoutId = null;

    constructor(props) {
        super(props);

        this.state = {
            index: props.index,
            mappingKey: props.mappingKey,
            mappingValue: props.mappingValue
        };
    }

    handleKeyMappingChange = (value) => {

        if (this.timeoutId != null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }

        this.setState({
            mappingKey: value
        });

        this.timeoutId = setTimeout(() => {
            this.props.onKeyChange(value, this.state.index)
        }, 300);
    }

    handleValueMappingChange = (value) => {

        if (this.timeoutId != null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }

        this.setState({
            mappingValue: value
        });

        this.timeoutId = setTimeout(() => {
            this.props.onValueChange(value, this.state.index)
        }, 300);
    }

    handleOnDelete = () => {
        this.props.onDelete(this.state.index);
    }

    handleShowProducts = () => {
        if (this.props.onShowProducts && this.state.mappingKey) {
            this.props.onShowProducts(this.state.mappingKey);
        }
    }

    static getDerivedStateFromProps(props, state) {

        if (state.index !== props.index || state.id !== props.id) {
            return {
                ...state,
                id: props.id,
                index: props.index,
                mappingKey: props.mappingKey,
                mappingValue: props.mappingValue
            }
        };

        return null;
    }

    render() {
        return <div style={{ 'paddingBottom': '10px' }}>
            <Stack alignment="center">
                {this.state.mappingKey && <Stack.Item>
                    <Button plain icon={CircleInformationMajor} onClick={this.handleShowProducts} />
                </Stack.Item>}
                <Stack.Item>
                    <TextField
                        placeholder="Option value"
                        value={this.state.mappingKey}
                        // error={hasName ? null : "Must have name"}
                        onChange={this.handleKeyMappingChange}
                        autoComplete="off"
                    />
                </Stack.Item>
                <Stack.Item>
                    <Icon
                        source={ChevronRightMinor}
                        color="base" />
                </Stack.Item>
                <Stack.Item fill>
                    <TextField
                        placeholder="Metafield value"
                        value={this.state.mappingValue}
                        // error={hasName ? null : "Must have name"}
                        onChange={this.handleValueMappingChange}
                        autoComplete="off"
                    />
                </Stack.Item>
                <Stack.Item>
                    <Button outline icon={DeleteMajor} onClick={this.handleOnDelete}></Button>
                </Stack.Item>
            </Stack>
        </div>
    }
}

export default ValueMappingComponent;